export default __webpack_public_path__ + "static/media/LessThanIcon.4b40da03.svg";